import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { addInterceptors } from '../serviceRtkQuery';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

export const axiosBaseQuery = (
  { baseUrl }: { baseUrl: string } = { baseUrl: '' },
): BaseQueryFn<
  {
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
  },
  unknown,
  unknown
> => {
  const axiosInstance = axios.create({ baseURL: baseUrl });

  addInterceptors(axiosInstance);
  return async ({ url, method, data, params }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
};
